import React from 'react';
import HeroSection from '../components/shared/HeroSection';
import SectionTitle from '../components/shared/SectionTitle';
import { heroImages, teamMembers } from '../data/mock';

const EquipePage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection
        image={heroImages.equipe}
        title="L'Équipe"
        subtitle="Une équipe soudée et passionnée à votre service"
        height="h-[50vh]"
      />

      {/* Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-neuropolitical font-bold text-emerald-800 mb-6">
            Foulées Vertes, c'est avant tout une équipe soudée et passionnée !
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Des profils différents, des parcours variés, mais une envie commune : partager notre savoir-faire, notre passion de la course à pied et donner le meilleur pour la satisfaction de nos clients. Découvrez les visages qui font vivre Foulées Vertes au quotidien !
          </p>
        </div>
      </section>

      {/* Team Members - Alternating Layout */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <SectionTitle
            title="Nos passionnés"
            subtitle="Rencontrez l'équipe Foulées Vertes"
          />

          <div className="space-y-16 mt-12">
            {teamMembers.map((member, index) => {
              const isEven = index % 2 === 1;
              const isKarim = index === 0;
              return (
                <div 
                  key={member.id} 
                  className={`grid lg:grid-cols-2 gap-8 items-center`}
                >
                  {/* Texte */}
                  <div className={`${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
                    <h3 className="font-bold text-3xl text-gray-900 mb-2">{member.name}</h3>
                    <p className="text-emerald-700 font-semibold text-xl mb-1">{member.nickname}</p>
                    <p className="text-gray-500 text-sm mb-4">{member.role}</p>
                    <p className="text-gray-600 text-lg leading-relaxed">{member.bio}</p>
                  </div>
                  {/* Image */}
                  <div className={`${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                    <div className="aspect-square bg-gray-200 rounded-2xl overflow-hidden shadow-lg max-w-md mx-auto">
                      <img 
                        src={member.photo}
                        alt={member.name}
                        className={`w-full h-full object-cover hover:scale-105 transition-transform duration-500 ${isKarim ? 'object-top' : ''}`}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-emerald-800 text-white">
        <div className="max-w-7xl mx-auto px-4">
          <SectionTitle
            title="Nos valeurs"
            subtitle="Ce qui nous anime au quotidien"
            light
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
            {[
              { title: 'Passion', desc: 'Le running est notre vie, pas juste notre métier' },
              { title: 'Expertise', desc: 'Des conseils fondés sur l\'expérience et la connaissance' },
              { title: 'Convivialité', desc: 'Un accueil chaleureux et personnalisé' },
              { title: 'Qualité', desc: 'Une sélection rigoureuse des meilleurs produits' }
            ].map((value, idx) => (
              <div key={idx} className="text-center">
                <div className="w-16 h-16 bg-emerald-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold">{idx + 1}</span>
                </div>
                <h3 className="font-semibold text-lg mb-2">{value.title}</h3>
                <p className="text-emerald-200 text-sm">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default EquipePage;
